import { formatAreaRange } from './formatAreaRange';
import { t } from './i18n';

// Design order: housing count, living area (layers icon), parcel (document
// icon). The visible chip is just icon + value; the aria-label spells out what
// the icon means. Shared by the project card and the map card so a project
// never shows two different spec rows.
export const projectSpecs = ({
  housingCount,
  parcelAreaRange,
  livingAreaRange,
  expectedHousingIndication
}) => {
  const living = formatAreaRange(livingAreaRange);
  const parcel = formatAreaRange(parcelAreaRange);
  const homes = housingCount
    ? t(housingCount === 1 ? 'project-card.spec.home' : 'project-card.spec.homes', {
        count: housingCount
      })
    : expectedHousingIndication || null;

  return [
    homes ? { icon: 'home', value: homes, aria: homes } : null,
    living
      ? { icon: 'layers', value: living, aria: `${t('listing-card.spec.living')} ${living}` }
      : null,
    parcel
      ? { icon: 'parcel', value: parcel, aria: `${t('listing-card.spec.parcel')} ${parcel}` }
      : null
  ].filter(Boolean);
};
